import { render } from "./InstanceView.vue?vue&type=template&id=2f879378&scoped=true&ts=true"
import script from "./InstanceView.vue?vue&type=script&lang=ts"
export * from "./InstanceView.vue?vue&type=script&lang=ts"

import "./InstanceView.vue?vue&type=style&index=0&id=2f879378&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f879378"]])

export default __exports__